import { LegalPageLayout } from "@/src/legal/components/legal-page-layout";

export function TermsPage() {
	return <LegalPageLayout documentKey="terms" />;
}
